import React from "react";

const ExcelIcon = () => {
  return (
    <svg
      width="219"
      height="116"
      viewBox="0 0 261 136"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7753_40483)">
        <rect x="6" y="6" width="249" height="124" rx="8" fill="white" />
        <rect
          x="6.5"
          y="6.5"
          width="248"
          height="123"
          rx="7.5"
          stroke="#FDEFD8"
        />
        <g clipPath="url(#clip0_7753_40483)">
          <path
            d="M103.122 24.0664H141.267C150.696 24.0664 158.339 31.7101 158.339 41.1392V96.0488H103.122V24.0664Z"
            fill="#EAEAEA"
          />
          <path d="M159.23 37.2336H144.465V22.4219" fill="#C5C5C5" />
          <path
            d="M160.339 98.2021H100.661V21.2979H146.142L160.354 36.1711V98.2021H160.339ZM102.891 95.9565H158.109V37.0786L145.173 23.5435H102.891V95.9565Z"
            fill="#EAEAEA"
          />
          <path
            d="M153.972 91.803H107.029V49.9209H153.987V91.803H153.972ZM109.26 89.5728H151.726V52.1665H109.26V89.5728Z"
            fill="#19AE57"
          />
          <path
            d="M158.297 52.6216L159.974 51.1496L166.146 58.182L164.469 59.654L158.297 52.6216Z"
            fill="#19AE57"
          />
          <path
            d="M94.9038 58.2017L101.076 51.1693L102.753 52.6412L96.5809 59.6736L94.9038 58.2017Z"
            fill="#19AE57"
          />
          <path
            d="M94.8936 58.1821V83.5452H166.107V58.1821H94.8936ZM124.133 75.947L121.933 72.1326L119.734 75.947H117.719L120.918 70.8252L117.796 65.7803H119.795L121.918 69.5332L124.056 65.7803H126.04L122.917 70.8252L126.163 75.947H124.133ZM134.376 75.947H127.916V65.7803H129.608V74.5935H134.361V75.947H134.376ZM142.297 75.3318C141.636 75.8394 140.775 76.0855 139.698 76.0855C138.667 76.0855 137.76 75.8086 136.991 75.2549C136.222 74.7012 135.853 73.9321 135.868 72.9324L135.884 72.8862H137.514C137.514 73.5015 137.729 73.9475 138.145 74.2705C138.56 74.5781 139.083 74.7319 139.683 74.7319C140.282 74.7319 140.744 74.6089 141.082 74.3474C141.421 74.1013 141.574 73.7476 141.574 73.3169C141.574 72.8862 141.421 72.5479 141.128 72.271C140.821 71.9941 140.298 71.7634 139.529 71.5481C138.437 71.2405 137.591 70.856 137.006 70.3638C136.406 69.8716 136.114 69.2256 136.114 68.4412C136.114 67.626 136.437 66.9492 137.099 66.4109C137.745 65.8879 138.591 65.6111 139.606 65.6111C140.698 65.6111 141.574 65.9033 142.236 66.4878C142.897 67.0723 143.205 67.8105 143.189 68.6719L143.174 68.718H141.544C141.544 68.1797 141.359 67.7644 141.005 67.4414C140.652 67.1184 140.175 66.9646 139.59 66.9646C139.021 66.9646 138.575 67.103 138.268 67.3645C137.96 67.6414 137.806 67.9797 137.806 68.4104C137.806 68.7949 137.975 69.1179 138.314 69.3794C138.652 69.6255 139.221 69.8716 140.006 70.1023C141.067 70.3945 141.882 70.8098 142.436 71.3174C142.99 71.825 143.266 72.4863 143.266 73.2861C143.297 74.1628 142.959 74.8396 142.297 75.3318Z"
            fill="#19AE57"
          />
          <rect
            x="7"
            y="6"
            width="247"
            height="180"
            fill="url(#paint0_linear_7753_40483)"
          />
          <rect
            x="15.375"
            y="104.375"
            width="50.25"
            height="19.25"
            rx="9.625"
            fill="#F3F1FC"
          />
          <rect
            x="15.375"
            y="104.375"
            width="50.25"
            height="19.25"
            rx="9.625"
            stroke="#E4DAFC"
            strokeWidth="0.75"
          />
          <path
            d="M24.2544 119V109.2H30.4424V110.348H25.6544V113.484H30.0224V114.604H25.6544V117.852H30.4424V119H24.2544ZM31.5105 119L33.9465 115.472L31.5105 111.944H33.0225L34.8705 114.688L36.7325 111.944H38.2305L35.7945 115.472L38.2305 119H36.7325L34.8705 116.242L33.0225 119H31.5105ZM42.3898 119.168C41.7084 119.168 41.1018 119.014 40.5698 118.706C40.0378 118.389 39.6178 117.955 39.3098 117.404C39.0111 116.853 38.8618 116.214 38.8618 115.486C38.8618 114.749 39.0111 114.105 39.3098 113.554C39.6178 112.994 40.0378 112.56 40.5698 112.252C41.1018 111.935 41.7084 111.776 42.3898 111.776C43.2484 111.776 43.9671 112 44.5458 112.448C45.1244 112.896 45.4931 113.503 45.6518 114.268H44.1958C44.1024 113.857 43.8878 113.54 43.5518 113.316C43.2251 113.092 42.8331 112.98 42.3758 112.98C42.0024 112.98 41.6571 113.078 41.3398 113.274C41.0224 113.461 40.7658 113.741 40.5698 114.114C40.3831 114.478 40.2898 114.931 40.2898 115.472C40.2898 115.873 40.3458 116.233 40.4578 116.55C40.5698 116.858 40.7191 117.119 40.9058 117.334C41.1018 117.549 41.3258 117.712 41.5778 117.824C41.8298 117.927 42.0958 117.978 42.3758 117.978C42.6838 117.978 42.9591 117.931 43.2018 117.838C43.4538 117.735 43.6638 117.586 43.8318 117.39C44.0091 117.194 44.1304 116.961 44.1958 116.69H45.6518C45.4931 117.437 45.1244 118.039 44.5458 118.496C43.9671 118.944 43.2484 119.168 42.3898 119.168ZM50.4819 119.168C49.8099 119.168 49.2126 119.014 48.6899 118.706C48.1672 118.398 47.7566 117.969 47.4579 117.418C47.1686 116.867 47.0239 116.228 47.0239 115.5C47.0239 114.753 47.1686 114.105 47.4579 113.554C47.7566 112.994 48.1672 112.56 48.6899 112.252C49.2126 111.935 49.8192 111.776 50.5099 111.776C51.2006 111.776 51.7932 111.93 52.2879 112.238C52.7826 112.546 53.1652 112.957 53.4359 113.47C53.7066 113.974 53.8419 114.534 53.8419 115.15C53.8419 115.243 53.8372 115.346 53.8279 115.458C53.8279 115.561 53.8232 115.677 53.8139 115.808H48.0459V114.814H52.4419C52.4139 114.226 52.2179 113.769 51.8539 113.442C51.4899 113.106 51.0372 112.938 50.4959 112.938C50.1132 112.938 49.7632 113.027 49.4459 113.204C49.1286 113.372 48.8719 113.624 48.6759 113.96C48.4892 114.287 48.3959 114.702 48.3959 115.206V115.598C48.3959 116.121 48.4892 116.564 48.6759 116.928C48.8719 117.283 49.1286 117.553 49.4459 117.74C49.7632 117.917 50.1086 118.006 50.4819 118.006C50.9299 118.006 51.2986 117.908 51.5879 117.712C51.8772 117.516 52.0919 117.25 52.2319 116.914H53.6319C53.5106 117.343 53.3052 117.731 53.0159 118.076C52.7266 118.412 52.3672 118.678 51.9379 118.874C51.5179 119.07 51.0326 119.168 50.4819 119.168ZM55.3973 119V108.92H56.7973V119H55.3973Z"
            fill="#15112D"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_7753_40483"
          x="0"
          y="0"
          width="261"
          height="136"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_7753_40483"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7753_40483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7753_40483"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7753_40483"
          x1="130.5"
          y1="6"
          x2="130"
          y2="186"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.612635" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_7753_40483">
          <rect
            width="247"
            height="124"
            fill="white"
            transform="translate(7 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExcelIcon;
